<template>
  <div class="page-content">
    <div class="page-body">
      <div class="membership-content">
        <div class="membership-margin">
          <!-- Registered user -->
          <div class="registered-user membership-details">
            <div class="membership-rules ml-2">
              <div class="membership-user-details">
                <div class="user-type mt-2">
                  <p class="font-size14"> {{ $t('membership.membership') }} </p>
                  <p class="user-type-value"> {{ $t('membership.registeredUser') }} </p>
                </div>
                <div class="price mt-2">
                  <p class="font-size14"> {{ $t('membership.fee') }} </p>
                  <p class="user-type-value"> {{ $t('membership.free') }} </p>
                </div>
              </div>
              <div class="membership-rules-details">
                <div class="user-type mt-2">
                  <p class="font-size14"> {{ $t('membership.includes') }} </p>
                </div>
                <div class="includes mt-2 mb-2">
                  <ul>
                      <li v-html="$t('membership.regInclude1')"> </li>                      
                      <li v-html="$t('membership.regInclude2')"> </li>
                      <li v-html="$t('membership.regInclude3')"> </li>
                      <li v-html="$t('membership.regInclude4')"> </li>                      
                  </ul>
                </div>
              </div>
            </div>
            <div class="membership-level mr-2" v-if="!isPaymentOrTrialInProcess">
              <div class="level"> {{ $t('membership.currentLevel') }} </div>
            </div>
          </div>
          <!-- Registered user end -->

          <!-- Premium user -->
          <div class="kulibri-supporter-details membership-details">
            <div class="membership-rules k-flex">
              <div class="membership-user-details kulibri-supporter ml-2" :class="{ 'kulibri-supporter-width': !isPaymentOrTrialInProcess }">
                <div class="membership-user-details">
                  <div class="user-type mt-2">
                    <p class="font-size14"> {{ $t('membership.membership') }} </p>
                    <p class="user-type-value"> {{ $t('membership.premiumUser') }} </p>
                  </div>
                  <div class="price extra-1-space mt-2">
                    <p class="font-size14"> {{ $t('membership.fee') }} </p>
                    <p class="user-type-value"> {{ getPlanPrice }} </p>
                  </div>
                </div>
                <div class="membership-rules-details mt-2">
                  <div class="user-type description">
                    <p class="font-size14"> {{ $t('membership.description') }} </p>
                  </div>
                  <div class="includes mt-2 mb-2">
                    <ul>
                        <li v-html="$t('membership.kulibriSupInclude1')"> </li>                        
                        <li v-html="$t('membership.kulibriSupInclude2')"> </li>
                        <li v-html="$t('membership.kulibriSupInclude3')"> </li>
                        <li v-html="$t('membership.kulibriSupInclude4')"> </li>                                                
                    </ul>
                  </div>
                </div>
                <div class="membership-rules-details" v-if="isPaymentOrTrialInProcess">
                  <div class="user-type description">
                    <p class="font-size14"> {{ $t('membership.paymentHeader') }} </p>
                  </div>
                  <div class="includes mt-2 mb-2">
                    <ul>
                        <li> {{ $t('membership.paymentInformation1', { paymentMethod: paymentMethod, cardNumber: cardNumber }) }} </li>
                        <li v-if="!isPaymentCanceled" v-html="$t('membership.paymentInformation2', {date: getNextPaymentDate})"> </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="membership-level mr-2" v-if="!isPaymentOrTrialInProcess">
                <!-- <p class="font-size14"> {{ $t('membership.whatToPay') }} </p> -->
                <div class="upgrade-plan">
                  <Btn
                    @click.native="makePayment()"
                    :label="$t('membership.upgradeToPremiumUser')"
                    :loading="isLoading"
                    :disabled="makeDisable"
                  />

                  <!-- <Btn
                    @click.native="openTrialModal()"
                    :label="$t('membership.dayTrial')"
                    :loading="isLoading"
                    class="mt-2"
                  /> -->
                </div>
              </div>
              <div class="membership-level mr-2" v-else>
                <div class="level" >
                  <span> {{ $t('membership.currentLevel') }} </span>
                  <!-- <span v-if="paymentSince" class="since">Since {{ paymentSince }} </span> -->
                </div>
                <!-- trial message -->
                <template v-if="!isPaymentCanceled">
                  <div class="trial-confirmation mt-2" v-if="!isPaymentComplete">
                    <p> {{ getTrialMessage }} </p>
                  </div>
                  <div class="trial-confirmation mt-2" v-else>
                    <p> {{ getSubscriptionMessage }} </p>
                  </div>

                  <div class="mt-2" v-if="isTrialStarted && !isTrialCompleted">
                    <Btn
                      @click.native="makePayment()"
                      :label="$t('membership.upgradeToPremiumUser')"
                      :loading="isLoading"
                      :disabled="makeDisable"
                    />
                  </div>
                </template>
                <template>
                  <div class="mt-2" v-if="!isPaymentCanceled && isPaymentComplete">
                    <Btn
                      @click.native="cancelPayment()"
                      :label="$t('membership.cancelSubscription')"
                      :loading="isLoading"
                      :disabled="makeDisable"
                    />
                  </div>
                  <div class="cancel-payment-details mt-2" v-if="isPaymentCanceled">
                    <p> {{ canclePaymentString }} </p>
                    <BtnLink
                      @click.native="openCancelModal"
                      :label="$t('membership.renew')"
                    />
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- Premium user end -->

        </div>
      </div>
    </div>
    <ModalDialog
      ref="dlgPaymentDialog"
      :title="dialogContent.title"
      :labelOk="dialogContent.okLabel"
      :showCancelIcon="true"
      :displayCancelButton="false"
      @ok="updateChoice(dialogContent.type)"
      @cancel="onCancel"
      :displayOkButton="true"
    >
    <!-- replace true with isPaymentComplete in displayOkButton -->
      <div class="text-small" v-html="dialogContent.description"></div>
    </ModalDialog>

    <ModalConfirm
      v-show="confirmCancelSubscription"
      :msg="$t('membership.confirmCacnelMembership')"
      @confirm="initiateCacelPayment"
      :loading="isCancelProcessContinue"
      @cancel="confirmCancelSubscription = false"
    />

  </div>
</template>

<script>
// import SelectField from '@/components/UI/SelectField';
import { HTTP } from '@/shared/http';
import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { constants } from '@/shared/constant';

export default {
  name: 'Membership',
  components: {
    // SelectField
  },
  data() {
    return {
      currentTabComponent: 'my-membership',
      okayToPay: 'willPay',
      paymentTypeSelection: { code: this.$t('membership.paymentTypeSelectionCode1'), label: this.$t('membership.paymentTypeSelectionLabel1') },
      payAmountSelection: { },
      reasonSelection: { code: this.$t('membership.reasonsCode1') , label: this.$t('membership.reasonLabel1') },
      paymentOptions: [],
      isLoading: false,
      isPaymentComplete: false,
      dialogContent: {title: '', description: '', type: '', okLabel: ''},
      paymentMethod: 0,
      cardNumber: '',
      paymentSince: null,
      confirmCancelSubscription: false,
      isCancelProcessContinue: false,
      isPaymentCanceled: false,
      isTrialCompleted: false,
      isTrialStarted: false
    };
  },
  created() {
    this.isLoading = true;
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('order_id')) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/subscribe/' +  urlParams.get('order_id');
      const user = {user_id: this.user.id};
      HTTP.post(url, user)
        .then((response) => {
          this.isLoading = false;
          if(response.data) {
            this.storeCurrentMembership(response.data);
            this.isTrialStarted = response.data.subscription.has_trial_start;
            this.isTrialCompleted = response.data.subscription.has_trial_expired;
            this.isPaymentCanceled = (response.data.subscription.cancel_status != null);
            if(response.data.status == 'paid') {
              this.paymentMethod = response.data.details.cardLabel;
              this.cardNumber = response.data.details.cardNumber;
              this.paymentSince = this.convertToDateFormat(response.data.subscription.start_date);
              this.isPaymentComplete = true;
              this.updateUserPlan();
            } else {
              this.isPaymentComplete = false;
            }
            let isPopupOpened = localStorage.getItem('isPopupOpen');
            if (isPopupOpened != 'true') {
              this.openModal(response.data);
            }
            const updatedUserData = response.data.user;
            updatedUserData.id = this.user.id;
            this.replaceExistingUserDetails(updatedUserData);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          const errorMessage = error.response.data.error ? error.response.data.error : error.response.data;
          alert(this.$t(errorMessage));
        });
    } else {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/user/' +  this.user.id + "/payment";
      HTTP.get(url)
        .then((response) => {
          this.isLoading = false;
          if(Object.keys(response.data).length > 0 &&  response.data) {
            this.storeCurrentMembership(response.data);
            this.isPaymentCanceled = (response.data.subscription.cancel_status != null);
            this.isTrialStarted = response.data.subscription.has_trial_start;
            this.isTrialCompleted = response.data.subscription.has_trial_expired;
            if(response.data.status == "paid") {
              if(response.data.subscription.subscription_id || response.data.subscription.status == "paid") {
                this.isPaymentComplete = true;
              }
              this.paymentMethod = response.data.details.cardLabel;
              this.cardNumber = response.data.details.cardNumber;
              this.paymentSince = this.convertToDateFormat(response.data.subscription.start_date);
              this.updateUserPlan();
            } else {
              this.isPaymentComplete = false;
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          const errorMessage = error.response.data.error ? error.response.data.error : error.response.data;
          alert(this.$t(errorMessage));
        });
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.Login.user,
    }),
    ...mapGetters([
      'currentMembership',
    ]),
    navItems() {
      let items = [
        { code: 'my-membership', label: this.$t('membership.tabMembership') },
        { code: 'my-invoices', label: this.$t('membership.tabInvoice') },
      ];
      return items;
    },
    paymentType() {
      let options = [
        { code: this.$t('membership.paymentTypeSelectionCode1'), label: this.$t('membership.paymentTypeSelectionLabel1') },
        { code: this.$t('membership.paymentTypeSelectionCode2'), label: this.$t('membership.paymentTypeSelectionLabel2') }
      ];
      return options;
    },
    reasons() {
      let options = [
        { code: this.$t('membership.reasonsCode1') , label: this.$t('membership.reasonLabel1') },
        { code: this.$t('membership.reasonsCode2') , label: this.$t('membership.reasonLabel2')},
        { code: this.$t('membership.reasonsCode3') , label: this.$t('membership.reasonLabel3')},
        { code: this.$t('membership.reasonsCode4') , label: this.$t('membership.reasonLabel4') }
      ];
      return options;
    },
    makeDisable() {
      // return (this.paymentOptions && this.paymentOptions.length == 0) || this.isLoading == true;

      // new code, uncomment above and remove the below line once we done with Premium User concept
      return this.isLoading == true
    },
    canclePaymentString() {
      return this.$t('membership.membershipWillEnd', {date: this.convertToDateFormat(this.currentMembership.subscription.end_date)});
      // return this.$t('membership.membershipWillEnd', {date: this.convertToDateFormat(this.currentMembership.end_date)});
    },
    getSubscriptionPrice() {
      if(this.currentMembership) {
        return this.currentMembership.subscription.membership.price + " / " + this.getPlanType(this.currentMembership.subscription.membership.interval);
      }
      return null;
    },
    getNextPaymentDate() {
      if(this.currentMembership) {
        return this.convertToDateFormat(this.currentMembership.subscription.end_date);
        // return this.convertToDateFormat(this.currentMembership.end_date);
      }
      return null;
    },
    isPaymentOrTrialInProcess() {
      return (this.isPaymentComplete || this.isTrialStarted);
    },
    getTrialMessage() {
      if(this.isTrialStarted) {
        if(this.isTrialCompleted) {
          return this.$t('membership.trialExpired', {date: this.convertToDateFormat(this.currentMembership.subscription.end_date)});
        } else {
          return "Your 14 days free trial ends at: " + this.convertToDateFormat(this.currentMembership.subscription.end_date);
        }
      }
      return ''
    },
    getSubscriptionMessage() {
      return this.$t('membership.subscriptionDate', {date: this.convertToDateFormat(this.currentMembership.subscription.start_date)});
    },
    getPlanPrice() {
      const price = constants.premiumUserPrice + constants.premiumUserVat;
      return this.$t('membership.yearPrice', {price: price});
    }
  },
  mounted() {
    this.$store.commit('setVisibleNav', true);
  },
  methods: {
    ...mapActions(['storeCurrentMembership', 'replaceExistingUserDetails', 'updatePlanForUser']),
    makePayment() {
      localStorage.removeItem('isPopupOpen');
      this.isLoading = true;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/subscription/' + this.user.id;
      HTTP.post(url)
      .then((response) => {
        this.isLoading = false;
        window.location.href = response.data._links.checkout.href;
      })
      .catch((error) => {
        this.isLoading = false;
        console.log(error);
        alert(this.$t(error.response.data.error));
      });
    },
    // getPlanPrice() {
    //   const planType = this.paymentTypeSelection.code == this.$t('membership.paymentTypeSelectionCode1') ? "1M" : "12M";
    //   const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
    //   const url = apiUrl + '/memberships/interval/' + planType;
    //   HTTP.get(url)
    //   .then((response) => {
    //     this.paymentOptions = response.data;
    //     if(this.paymentOptions.length > 0) {
    //       this.payAmountSelection = this.paymentOptions[0];
    //     }
    //   })
    //   .catch((error) => console.log(error));
    // },
    updateChoice(type) {
      this.$refs.dlgPaymentDialog.closeModal();
      if(type == 'cancel') {
        this.confirmCancelSubscription = true;
      } else if(type == 'payment') {
        this.$router.push('/pr/new');
      } else if(type == 'trial') {
        this.startTrial();
      }
    },
    openModal(data) {
      if(data.subscription && data.subscription.cancel_status) {
        this.isPaymentCanceled = true;
        this.isPaymentComplete = true;
      } else {
        if(data.status == "paid") {
          this.dialogContent.title = this.$t('membership.congratulations');
          this.dialogContent.description = this.$t('membership.upgradedTo', {slag: this.$t('membership.successfully'), packageName: this.$t('membership.premiumUser')}) + this.$t('membership.thankYouMessage');
          // this.isPaymentComplete = true;
        } else if(data.status == "failed") {
          this.dialogContent.title = this.$t('membership.paymentFailed');
          this.dialogContent.description = this.$t('membership.upgradedTo', {slag: this.$t('membership.triedTo'), packageName: this.$t('membership.premiumUser')}) +
            this.$t('membership.paymentFailedReason', {reason: data.details.failureMessage}) +
            this.$t('membership.feelFree');
          // this.isPaymentComplete = false;
        } else {
          this.dialogContent.title = this.$t('membership.paymentNotCompleted');
          this.dialogContent.description = this.$t('membership.paymentNotCompletedDescription');
          // this.isPaymentComplete = false;
        }
        this.dialogContent.type = 'payment';
        this.dialogContent.okLabel = this.$t('membership.createProject');
        this.$refs.dlgPaymentDialog.openModal();
        localStorage.setItem('isPopupOpen', 'true');
      }
    },
    convertToDateFormat(date) {
      if(date) {
        return moment(String(date)).format('DD.MM.YYYY')
      }
    },
    getPlanType(type) {
      switch(type) {
        case '1M':
          return 'Month'
        case '12M':
          return 'Year'
        default:
          return ''
      }
    },
    cancelPayment() {
      this.dialogContent.title = this.$t('membership.cancelDialogHeader');
      this.dialogContent.description = this.$t('membership.cancelDialogDescription', {packageName: this.$t('membership.premiumUser')}) +
        this.$t('membership.renewPayment', {date: this.convertToDateFormat(this.currentMembership.renew_date)}) +
        this.$t('membership.cancelMembershipDescription', {date: this.convertToDateFormat(this.currentMembership.renew_date)});

      this.dialogContent.type = 'cancel';
      this.dialogContent.okLabel = this.$t('membership.cancelSubscription');
      this.$refs.dlgPaymentDialog.openModal();
    },
    initiateCacelPayment() {
      this.isCancelProcessContinue = true;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/user/' +  this.user.id + "/cancel-subscription";
      HTTP.post(url)
        .then((response) => {
          this.isLoading = false;
          this.isCancelProcessContinue = false;
          this.confirmCancelSubscription = false;
          if(response.data.cancel_status) {
            this.isPaymentCanceled = true;
            this.isPaymentComplete = true;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          alert(this.$t(error.response.data));
        });
    },
    openCancelModal() {
      this.dialogContent.title = this.$t('membership.renewDialogHeader');
      this.dialogContent.description = this.$t('membership.renewDialogDescription');
      this.dialogContent.type = 'reNew';
      this.dialogContent.okLabel = 'OK';
      this.$refs.dlgPaymentDialog.openModal();
    },

    // new design methods
    openTrialModal() {
      this.dialogContent.title = this.$t('membership.startYourTrial');
      this.dialogContent.description = this.$t('membership.trialConfirmation') + "<br/><br/><b>" +this.$t('membership.premiumUser') + "</b>";
      this.dialogContent.okLabel = this.$t('membership.startTrialNow');
      this.dialogContent.type = 'trial';
      this.$refs.dlgPaymentDialog.openModal();
    },
    startTrial() {
      this.isLoading = true;
      this.isTrialStarted = false;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/start-trial/' + this.user.id;
      HTTP.post(url)
      .then((response) => {
        this.isLoading = false;
        this.isTrialStarted = response.data.subscription.has_trial_start || false;
        this.storeCurrentMembership(response.data);
        this.updateUserPlan();
        // console.log(response);
      })
      .catch((error) => {
        this.isLoading = false;
        console.log(error);
        alert(this.$t(error.response.data));
      });
    },
    updateUserPlan() {
      this.updatePlanForUser(1);
      // this.user.plan = true;
    },
    onCancel() {
      this.$refs.dlgPaymentDialog.closeModal();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';

.page-content {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: $very-light-grey;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.page-body {
  overflow: auto;
}

.membership-navigation {
  background-color: white;
  padding-top: 68px;
  flex-shrink: 0;
  flex-grow: 0;
  }

.membership-content {
  display: flex;
  flex-direction: column;
}

.membership-margin {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: $mobile-margin-left;
  padding-right: $mobile-margin-left;
  color: $dark-grey;
}

.membership-user-details {
  display: flex;
}

.kulibri-supporter {
  display: block;
}

.kulibri-supporter-width {
  width: 50%;
}

.membership-rules-details {
  padding-bottom: 1px;
}

.membership-details {
  max-width: 800px;
  color: $white;
  background-color: $membership;
  border-radius: 9px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

// remove upgrade-plan when we removed the premium user plan
.membership-level, .upgrade-plan {
  width: 20%;
  // align-self: center;
  text-align: center;
  color: $dark-grey;
  font-weight: $medium-weight;
  font-size: $big-extra;
  line-height: 28px;
  padding: 5px 10px;
  border-radius: 5px;

  .level {
    background-color: $user-bubble;
    border-radius: 5px;
  }
}

.font-size12 {
  font-size: $very-small;
}

.font-size14 {
  font-size: $small;
  line-height: 18px;
  font-weight: $medium-weight;
}

.user-type-value {
  font-size: $big-extra;
  font-weight: $medium-weight;
  line-height: 30px;
}

.user-type p, .price p, .cancel-payment-details p, .trial-confirmation p {
  margin-bottom: 0px;
}

.price {
  margin-left: 3rem;
}
.extra-1-space {
  margin-left: 4rem !important;
}

ul li::marker {
  color: $primary;
  font-size: $big;
}

.currently-used-poll {
  color: $user-bubble;
}

.okay-to-pay, .not-to-pay {
  font-size: $small;
  display: flex;
  justify-content: space-between;
  line-height: 18px;
  font-weight: $regular-weight;
}

.pay-details {
  font-size: $very-small;
  line-height: 14px;
  font-weight: $regular-weight;
}

::v-deep .reason {
  #dropdownMenuButton {
    width: 320px !important;
  }
}

.plan-type {
  display: flex;
  margin-left: 60px;
}

::v-deep .plan-type, ::v-deep .plan-price, ::v-deep .reason {
  #dropdownMenuButton {
    font-size: $small !important;
    line-height: 18px !important;
    font-weight: $regular-weight !important;
  }
}

.plan-details {
  margin-top: 27px;
}

.upgrade-plan {
  // uncomment this css when remove premium user
  // text-align: end;

  // comment this css when remove premium user
  width: 100% !important;
  padding: unset !important;
  button {
    width: 100%;
  }
}

// .trail-btn {
//   background-color: $user-bubble !important;
//   border-color: $user-bubble !important;
// }

.not-available {
  background-color: #adb0b6;
  color: $white;
  font-weight: 400;
}

.includes {
  font-weight: $regular-weight;
  font-size: $small;
  line-height: 18px;

  ul {
    margin-left: -22px;
  }
}

.registered-user, .kulibri-supporter-details, .kulibri-pro {
  margin-top: 32px !important;
}

.membership-rules.k-flex {
  justify-content: space-between;
}

.since {
  display: flex;
  font-size: $very-small;
  justify-content: center;
}

.cancel-payment-details, .trial-confirmation {
  font-size: $very-small;
  line-height: 14px;
  color: $white;
}

.trial-confirmation {
  color: $user-bubble;
}

@media screen and (min-width: 481px) {
  .membership-margin {
    margin-left: $desktop-margin-left !important;
    padding: 0px;
  }
}

@media screen and (max-width: 481px) {
  .page-content{
    height: fit-content !important;
  }
  .price {
    margin-left: 0 !important;
  }
  .membership-user-details, .okay-to-pay, .not-to-pay {
    display: block;
  }
  .membership-level {
    align-self: flex-start;
    margin-top: 0.5rem;
    font-weight: $medium-weight;
    font-size: $standard;
    line-height: 20px;
  }
  .membership-rules.k-flex {
    display: block;
  }
  .kulibri-supporter-width {
    width: 100%;
  }
  .plan-type {
    margin-left: 15px;
    margin-top: 0.5rem;
    justify-content: space-between;
  }
  .reason {
    margin-left: 15px;
    margin-top: 0.5rem;
  }
  .membership-level {
    width: unset;
  }

  .plan-price {
    margin-left: 20px;
  }

  ::v-deep .plan-type, ::v-deep .reason {
    #dropdownMenuButton {
      width: 100% !important;
    }
  }
}
</style>
